import { ChangeDetectionStrategy, Component, EventEmitter,  OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { PqqSectionsComponent } from '../pqq-sections.component';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import {provideNativeDateAdapter} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { OrganizationService } from '@/app/services/organization/organization.service';
@Component({
  selector: 'app-submission-guidelines-info',
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    MatIcon,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    RichTextEditorComponent,MatDatepickerModule
  ],
   changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './submission-guidelines-info.component.html',
  styleUrl: './submission-guidelines-info.component.css',
})
export class SubmissionGuidelinesInfoComponent implements OnInit {
  isEdit = false;
  eoiTitle: FormControl<any>;
  projectName: string;
  submittedGuidlines: any;
  projectIdentifier: string;

  constructor(
    private PqqSectionsComponent: PqqSectionsComponent,
    private projectsService: ProjectsService,
    private toast: NgToastService,
    private router: Router,
    private TenderingService: TenderingService,
    private organizationService: OrganizationService,
  ) {}
  @Output() closeModalEvent = new EventEmitter<boolean>(); // EventEmitter to notify parent

  form: FormGroup;
  closeModal = true;
  orgInfo: any = {};

  ngOnInit(): void {

    this.orgInfo = this.organizationService.getLoggedInUserOrganization();
    this.TenderingService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });
    this.projectIdentifier = this.TenderingService.getProjectIdentifier();
    this.projectName = localStorage.getItem('project-name');
    this.form = new FormGroup({
      referenceNumber: new FormControl({ value: '', disabled: true }, Validators.required),
      client_or_authority: new FormControl({ value: this.orgInfo.name, disabled: true }, Validators.required),
      date_issue: new FormControl('', Validators.required),
      submission_deadline: new FormControl('', Validators.required),
    });

    this.getSubmittedGuidlines();
  }

  moveToPreviousStep() {
    this.PqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    if (this.form.valid) {
      const pqqId = this.TenderingService.getPqqId();

      const formData = this.form.getRawValue(); // Get all values, including disabled ones

      const data = {
        pqq_id: pqqId,
        client: formData.client_or_authority,
        issue_date: this.form.value.date_issue,
        submission_deadline: this.form.value.submission_deadline,
      };
      return data;
    }
  }

  moveToNextStep() {

    this.form.markAllAsTouched();

    if (this.form.invalid) {
      // Exit early if the form is invalid
      this.toast.warning('Please fill in all required fields.', 'WARNING', 4000);
      return;
    }else{
      const dataToSubmit = this.prepareDataToSubmit();
      this.TenderingService.projectPqqInitiateStep3(dataToSubmit).subscribe({
        next: () => {
          this.toast.success('Guidlines Submitted', 'SUCCESS');
          this.closeModalEvent.emit(this.closeModal);
  
          this.TenderingService.setEditState(false);
          const pqqId = this.TenderingService.getPqqId();
          const projectId = localStorage.getItem('projectId');
          this.router.navigate(['/initiate-pqq', projectId, pqqId], {
            queryParams: { projectName: this.projectName, projectIdentifier: this.projectIdentifier },
          });
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    }
  }
  handleBack() {
    this.PqqSectionsComponent.previousStep();
  }

  getSubmittedGuidlines(): any {
    return this.projectsService.getSubmittedInitiationDataPQQ().subscribe({
      next: (response: any) => {
        this.submittedGuidlines = response?.data;
        if (response?.data) {
          this.form.patchValue({
            referenceNumber: response?.data?.reference_number,
            submission_deadline: response?.data?.submission_deadline,
            date_issue: response?.data?.issue_date,
            client_or_authority: response?.data?.client ? response?.data?.client : this.orgInfo.name,
          });
        }
      },
      error: (error) => {
        console.error('Error fetching record of Work Packages:', error);
      },
    });
  }
}
